import { useParams } from "react-router-dom"

import { PageHeader } from "components/Header/PageHeader"
import { makeSource } from "utils/helpers"
import { Footer, Layout } from "components"
import { BookingDetails } from "modules/PsychologistAccount/BookingDetails/BookingDetails/BookingDetails"
import { useShowPrice } from "utils/hooks/useShowPrice"

export function BookingDetailsWrapper() {
    const params = useParams<{ id: string }>()
    const showPrice = useShowPrice()

    return (
        <Layout className="booking-details-page">
            <PageHeader openLogo={{ newTab: true }} showRight="menu" />
            {params.id && (
                <BookingDetails
                    source={makeSource("manual")}
                    bookingHash={params.id}
                    showPrice={showPrice}
                />
            )}
            <Footer />
        </Layout>
    )
}
